export default __webpack_public_path__ + "static/media/placeholder-cover.7cfdb7d9.svg";